<div class="page-container">
  <app-hero-section></app-hero-section>
  <app-problems-section></app-problems-section>
  <app-testimonials-section></app-testimonials-section>
  <app-finance-education-plan></app-finance-education-plan>
  <app-usp-section></app-usp-section>
  <app-hesitation-section></app-hesitation-section>
  <app-commitment-section></app-commitment-section>
  <app-testimonial-section></app-testimonial-section>
  <app-doubt-section></app-doubt-section>
  <app-faq></app-faq>
  <app-disclaimer-banner></app-disclaimer-banner>
  <app-contact-section></app-contact-section>

</div>
